__turbopack_context__.v({
  "brand": "NewPasswordView-module__YvVBfW__brand" + " " + __turbopack_context__.i(36980)["brand"],
  "brandName": "NewPasswordView-module__YvVBfW__brandName" + " " + __turbopack_context__.i(36980)["brandName"],
  "card": "NewPasswordView-module__YvVBfW__card" + " " + __turbopack_context__.i(36980)["card"],
  "error": "NewPasswordView-module__YvVBfW__error" + " " + __turbopack_context__.i(36980)["error"],
  "field": "NewPasswordView-module__YvVBfW__field" + " " + __turbopack_context__.i(36980)["field"],
  "fields": "NewPasswordView-module__YvVBfW__fields" + " " + __turbopack_context__.i(36980)["fields"],
  "headline": "NewPasswordView-module__YvVBfW__headline" + " " + __turbopack_context__.i(36980)["headline"],
  "root": "NewPasswordView-module__YvVBfW__root" + " " + __turbopack_context__.i(36980)["root"],
  "submit": "NewPasswordView-module__YvVBfW__submit" + " " + __turbopack_context__.i(36980)["submit"],
  "switch": "NewPasswordView-module__YvVBfW__switch" + " " + __turbopack_context__.i(36980)["switch"],
  "tagline": "NewPasswordView-module__YvVBfW__tagline" + " " + __turbopack_context__.i(36980)["tagline"],
});
